<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <img src="assets/lacivert-logo.svg" alt="Logo" class="logo" style="filter: brightness(0);">
      <h2>KAPTAN PANELİ</h2>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <div class="form-group">
        <label for="username">Kullanıcı Adı</label>
        <input type="text" id="username" formControlName="username" placeholder="Kullanıcı adınızı girin"
          [class.error]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
      </div>
      <div class="form-group">
        <label for="password">Şifre</label>
        <input type="password" id="password" formControlName="password" placeholder="Şifrenizi girin"
          [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
      </div>
      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>
      <button type="submit" class="login-button" [disabled]="loginForm.invalid || isLoading">
        <span *ngIf="!isLoading">Giriş Yap</span>
        <span *ngIf="isLoading">Giriş yapılıyor...</span>
      </button>
    </form>
  </div>
</div>